module.exports = __webpack_public_path__ + "img/NKFIA_infoblokk_kerettel_projekt_fekvo_2019_HU.028bc05a.png";